import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import DashboardExcelButton from "@components/CompDashboard/DashboardExcelButton";
import DashboardHeaderLeft from "@components/CompDashboard/DashboardMainHeader/DashboardHeaderLeft";
import DashboardHeaderRight from "@components/CompDashboard/DashboardMainHeader/DashboardHeaderRight";

const label = { inputProps: { "aria-label": "Checkbox data" } }; // 전체기간 라벨

const DashboardMainHeader = ({
  filterAD,
  check,
  handleExcel,
  onPopup,
  handleClick,
  adCheck,
  advertiserCheck,
  handleChecked,
  dates,
  op,
  setOp,
  handleChangeDate,
  openEnd,
  setOpenEnd,
}) => {
  return (
    <Paper
      sx={{
        boxShadow: 0,
        pl: 5,
        pr: 5,
        pt: 2.875,
        pb: 2.875,
        borderRadius: "10px",
        border: "1px solid #EEEEEF",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid container alignItems="flex-start" justifyContent="center">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container justifyContent="space-between">
            <Grid container sx={{ width: "50%" }}>
              <DashboardHeaderLeft
                onPopup={onPopup}
                onClick={handleClick}
                adData={filterAD}
                advertiserCheck={advertiserCheck}
                adCheck={adCheck}
              />
            </Grid>
            <Grid container sx={{ width: "50%" }}>
              <DashboardHeaderRight
                label={label}
                check={check}
                handleChecked={handleChecked}
                dates={dates}
                op={op}
                handleChangeDate={handleChangeDate}
                setOp={setOp}
                openEnd={openEnd}
                setOpenEnd={setOpenEnd}
              />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ width: 140 }}>
          <DashboardExcelButton onClick={handleExcel} />
        </Box>
      </Grid>
    </Paper>
  );
};

export default DashboardMainHeader;
